export default __webpack_public_path__ + "static/media/learose3.06732e40.jpg";